import CipherActions from "./CipherActions";
import CipherName from "./CipherName";
import FolderActions from "./FolderActions";
import FolderName from "./FolderName";

const sharedCipherComponents = {
  CipherActions,
  CipherName,
  FolderActions,
  FolderName
}

export default sharedCipherComponents;